const Pricing = () => {
  return (
    <div className="container background_light">
      <div className="column w64 g1">
        <h2>Pricing</h2>
        <div className="columns g1">
          <div className="card column g1">
            <div className="flex g1">
              <img
                className="icon_small"
                src={require("../../images/check.png")}
                alt="check"
              />
              <strong className="purple">Essentials</strong>
            </div>
            <div className="column g1">
              <div className="flex between">
                <strong>Small business</strong>
                <span>$350/month</span>
              </div>
              <div className="flex between">
                <strong>Medium business</strong>
                <span>$1,725/month</span>
              </div>
              <div className="flex between">
                <strong>Large business</strong>
                <span>$3,500/month</span>
              </div>
            </div>
          </div>
          <div className="card column g1 background_white shadow">
            <div className="flex g1">
              <img
                className="icon_small"
                src={require("../../images/premium.png")}
                alt="check"
              />
              <strong className="purple">Premium</strong>
            </div>
            <div className="column g1">
              <div className="flex between">
                <strong>Small business</strong>
                <span>$1,000/month</span>
              </div>
              <div className="flex between">
                <strong>Medium business</strong>
                <span>$3,500/month</span>
              </div>
              <div className="flex between">
                <strong>Large business</strong>
                <span>$5,000/month</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
